import { useAuth } from "@/contexts/AuthContext";
import { useUserRole } from "@/hooks/useUserRole";
import { useEffect } from "react";

interface AdSenseAdProps {
  slot: string;
  format?: string;
  responsive?: boolean;
  style?: React.CSSProperties;
}

export function AdSenseAd({ 
  slot, 
  format = "auto", 
  responsive = true,
  style = { display: 'block' }
}: AdSenseAdProps) {
  const { user } = useAuth();
  const { role } = useUserRole();

  // Only show ads for non-logged in users or free tier users
  const shouldShowAd = !user || role === 'free';

  useEffect(() => {
    if (shouldShowAd) {
      try {
        // @ts-ignore
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (err) {
        console.error('AdSense error:', err);
      }
    }
  }, [shouldShowAd]);

  if (!shouldShowAd) {
    return null;
  }

  return (
    <div className="my-8 flex justify-center">
      <ins
        className="adsbygoogle"
        style={style}
        data-ad-client="ca-pub-1618387047783848"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive.toString()}
      />
    </div>
  );
}
